/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Stat_Countries_LabelInputs */

const en_landing_stat_countries_label = /** @type {(inputs: Landing_Stat_Countries_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EU languages`)
};

const de_landing_stat_countries_label = /** @type {(inputs: Landing_Stat_Countries_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EU-Sprachen`)
};

const fr_landing_stat_countries_label = /** @type {(inputs: Landing_Stat_Countries_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Langues de l'UE`)
};

const es_landing_stat_countries_label = /** @type {(inputs: Landing_Stat_Countries_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idiomas de la UE`)
};

const it_landing_stat_countries_label = /** @type {(inputs: Landing_Stat_Countries_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lingue UE`)
};

const nl_landing_stat_countries_label = /** @type {(inputs: Landing_Stat_Countries_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EU-talen`)
};

const pl_landing_stat_countries_label = /** @type {(inputs: Landing_Stat_Countries_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Języki UE`)
};

const fi_landing_stat_countries_label = /** @type {(inputs: Landing_Stat_Countries_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EU-kielet`)
};

const da_landing_stat_countries_label = /** @type {(inputs: Landing_Stat_Countries_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EU-sprog`)
};

const sv_landing_stat_countries_label = /** @type {(inputs: Landing_Stat_Countries_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EU-språk`)
};

/**
* | output |
* | --- |
* | "EU languages" |
*
* @param {Landing_Stat_Countries_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_stat_countries_label = /** @type {((inputs?: Landing_Stat_Countries_LabelInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Stat_Countries_LabelInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_stat_countries_label(inputs)
	if (locale === "fr") return fr_landing_stat_countries_label(inputs)
	if (locale === "es") return es_landing_stat_countries_label(inputs)
	if (locale === "it") return it_landing_stat_countries_label(inputs)
	if (locale === "nl") return nl_landing_stat_countries_label(inputs)
	if (locale === "pl") return pl_landing_stat_countries_label(inputs)
	if (locale === "fi") return fi_landing_stat_countries_label(inputs)
	if (locale === "da") return da_landing_stat_countries_label(inputs)
	if (locale === "sv") return sv_landing_stat_countries_label(inputs)
	return en_landing_stat_countries_label(inputs)
});